import { route } from 'preact-router';
import { useEffect } from 'preact/hooks';
import { API_BASE_URL } from '../../config.js';
import { useAuth } from '../../context/AuthContext.js';
import { resolvePostSignInDestination } from '../../services/signInReturnPath.js';

interface AuthCallbackPageProps {
  path?: string;
}

export function AuthCallbackPage(_props: AuthCallbackPageProps) {
  const { setTokens } = useAuth();

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional mount-only OAuth exchange
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (!code) {
      route('/account/login');
      return;
    }

    fetch(`${API_BASE_URL}/auth/google/exchange`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Exchange failed');
        return res.json() as Promise<{ access_token: string; refresh_token: string }>;
      })
      .then(async ({ access_token, refresh_token }) => {
        await setTokens(access_token, refresh_token);
        // 079 D3: the same resolver the two LoginPage arms call. Google returns to a fresh
        // document, so this is the arm that proves the destination outlived the reload — and the
        // arm a fix touching only LoginPage would leave discarding the visitor's intent.
        route(resolvePostSignInDestination());
      })
      .catch(() => route('/account/login'));
  }, []);

  return (
    <div class="page-fill bg-bg flex items-center justify-center">
      <p class="text-gray-400">Signing you in…</p>
    </div>
  );
}
